<template>
  <div>
    <contact-us-desktop v-if="screenType === 'desktop'"></contact-us-desktop>
    <contact-us-mobile v-else></contact-us-mobile>
  </div>
</template>

<script>
import ContactUsDesktop from "@/components/Pages/Desktop/ContactUs/ContactUsDesktop";
import ContactUsMobile from "@/components/Pages/Mobile/ContactUs/ContactUsMobile";

export default {
  name: "ContactUsMain",
  components: {ContactUsMobile, ContactUsDesktop},
  data() {
    return {
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop'
    }
  }
}
</script>

<style scoped>

</style>